import { render } from "./Loader.vue?vue&type=template&id=4bd2cf6c&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=4bd2cf6c&scoped=true&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd2cf6c"]])

export default __exports__